import { useState } from "react";
import AttendeeList from "./AttendeeList";
import Tabs from "../../../../elements/Tabs";
import { Link, useOutletContext } from "react-router-dom";
import AttendeeExportsList from "./AttendeeExportList";
import { t } from "i18next";

// Main Attendees Component
const AttendeeManage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { event, selectedLanguage } = useOutletContext();

  // Tab items configuration
  const tabs = [
    {
      label: t("Preview"),
      content: <AttendeeList />,
    },
    {
      label: t("Exports"),
      content: <AttendeeExportsList />,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <Link
            to={`/${selectedLanguage}/user/myEvent/report/${event?.data?.uid}`}
          >
            <div className="flex items-center gap-2 text-blue-600 mb-4">
              <i className="fas fa-chevron-left"></i>
              <span className="text-sm font-medium">{t("Event Reports")}</span>
            </div>
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            {t("Attendees")}
          </h1>
          <p className="text-gray-600 font-medium">
            {t("Manage and view attendees registered for the event.")}
          </p>
        </div>
        <Tabs
          items={tabs}
          setSelectedIndex={setSelectedIndex}
          selectedIndex={selectedIndex}
        />
      </div>
    </div>
  );
};

export default AttendeeManage;
